<template>
  <el-dialog
    v-el-drag-dialog
    :title="$t('CargoMsg.Cargo_BindApprovalTemplate')"
    :visible="visible"
    :close-on-click-modal="false"
    append-to-body
    class="bill-payment-apply-dialog"
    :before-close="handleClose"
    width="760px"
  >
    <div>
      <h1>{{ workflowTitle }}</h1>
      <table class="details-table" cellpadding="0" cellspacing="0">
        <tr>
          <td class="header">{{ $t('CargoMsg.Cargo_ApprovalSerialNumber') }}</td>
          <td class="values" />
          <td class="header">{{ $t('CargoMsg.Cargo_StartDate') }}</td>
          <td class="values" />
        </tr>
        <tr>
          <td class="header">{{ $t('CargoMsg.Cargo_Applicant') }}</td>
          <td class="values" />
          <td class="header">{{ $t('CargoMsg.Cargo_PaymentApplicationNo') }}</td>
          <td class="values" />
        </tr>
        <tr>
          <td class="header">{{ $t('CargoMsg.Cargo_BusinessType') }}</td>
          <td class="values" />
          <td class="header">{{ $t('CargoMsg.Cargo_InitiateBranchCompany') }}</td>
          <td class="values" />
        </tr>
        <tr>
          <td class="header">{{ $t('CargoMsg.Cargo_DateOfApplication') }}</td>
          <td class="values" />
          <td class="header">{{ $t('CargoMsg.Cargo_InitiateDepartment') }}</td>
          <td class="values" />
        </tr>
        <tr>
          <td class="header">{{ $t('CargoMsg.Cargo_PaymentPeriod') }}</td>
          <td class="values" />
          <td class="header">{{ $t('CargoMsg.Cargo_PaymentMethod') }}</td>
          <td class="values" />
        </tr>
        <tr>
          <td class="header">{{ $t('CargoMsg.Cargo_Amount') }}</td>
          <td class="values" />
          <td class="header">{{ $t('CargoMsg.Cargo_Currency') }}</td>
          <td class="values" />
        </tr>
        <tr>
          <td class="header">{{ $t('Payment.ourDepositBank') }}</td>
          <td class="values" />
          <td class="header">{{ $t('Payment.ourBankAccount') }}</td>
          <td class="values" />
        </tr>
        <tr>
          <td class="header">{{ $t('CargoMsg.Cargo_Remarks') }}</td>
          <td class="values" />
        </tr>
      </table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'BillPaymentApplyForm',
  props: {
    workflowTitle: { type: String, default: () => '' },
    visible: { type: Boolean, default: () => false }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
